import React from 'react';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import LandingPage from './LandingPage';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1e40af' },
    secondary: { main: '#7c3aed' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LandingPage />
    </ThemeProvider>
  );
}

export default App;
